<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="co-payments-sections-container">
		<v-flex mb2 d-flex xs12 pa-0 grow v-if="step === $const.STEP_PAYMENT && false">
			<div class="co-section">
				<v-card flat width="100%" class="mb-1">
					<div>
						<div>
							<div class="section-title no-border">
								<h1 v-bind="ADAattr('h1')" style="border: none;">
									<span>Your Flexpay amount: <strong>${{ 9999 }}</strong></span>
								</h1>
							</div>


							<v-expand-transition>
								<div v-if="placing_order">
									<div class="co-submit-placing-order">
										<h4>Placing your order...</h4>
										<v-progress-linear :indeterminate="true"
														   v-bind="ADAattr('progress', 'Please wait, we are placing your order')"/>
									</div>
								</div>
							</v-expand-transition>

						</div>

					</div>
				</v-card>
			</div>
		</v-flex>

		<v-flex mb2 d-flex xs12 pa-0 v-if="step === $const.STEP_PAYMENT">
			<div class="co-section">
				<v-card flat>
					<div class="py-3">
						<div class="co-submit-panel">
							<order-summary
									:charges="summary.charges"
									:payments="summary.payments"
									:total="summary.total"
									:flexpay-store="$globs['flex_pay_store']"
									v-bind="ADAattr('sr-only')"
							/>
							<v-btn
									:dark="!placing_order"
									color="#4185F4"
									class="mx-0"
									@click="submit"
									id="send-order-for-approval"
									v-bind="ADAattr('button-readonly', !submit_enabled || placing_order,
									`Submit payment for $${formatPrice(summary['total'])}`,
									!submit_enabled ? 'Please check all fields before continue' : 'Please wait')"
							>
								Submit order for approval
							</v-btn>

							<div class="co-submit-total" v-if="summary['total']">
								Order Total: <strong>${{ formatPrice(summary['total']) }}</strong>
							</div>
						</div>
						<div class="co-submit-panel" v-if="$globs['is_inst'] && false">
							<v-checkbox
									:disabled="placing_order"
									v-model="share_order_info"
									label="I agree to allow my order information to be shared with my school administration"
									hide-details
							/>
						</div>
					</div>
				</v-card>
			</div>
		</v-flex>

		<v-dialog
				v-model="captcha_dialog"
				width="500"
		>
			<v-card v-bind="[
				ADAattr('dialog', !captcha_dialog, 'ada-cptd'),
				ADAfocus('captcha_dialog')
			]">
				<v-card-title
						class="headline grey lighten-2"
						primary-title
						v-bind="ADAattr('h2')"
						id="ada-cptd"
				>
					Please Confirm You Are Not a Robot
				</v-card-title>

				<v-card-text>
					<vue-recaptcha
							ref="recaptcha_coupon"
							@verify="onCaptchaVerify"
							:sitekey="$globs['captcha_settings']['public_key']"
							size="normal"
					>
					</vue-recaptcha>
				</v-card-text>

				<v-divider v-bind="ADAattr('hidden')"></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
							color="primary"
							flat
							@click="captcha_dialog = false"
							v-bind="ADAattr('label', 'Return')"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import OrderSummary from './OrderSummary';
	import _ from 'lodash';
	import Axios from 'axios';
	import {EventBus} from './../includes/EventBus';
	import {parseErrorResponse, formatPrice, formatBraintreeFieldName} from './../includes/Miscellaneous';
	import VueRecaptcha from 'vue-recaptcha';

	class Address {
		constructor(data = {}) {
			this.id = data['id'] || '';
			this.name = data['name'] || '';
			this.line1 = data['line1'] || '';
			this.line2 = data['line2'] || '';
			this.city = data['city'] || '';
			this.state = data['state'] || '';
			this.postal_code = data['postal_code'] || '';
			this.country = data['country'] || '';
			this.phone = data['phone'] || '';
			this.source = data['source'] || '';
		}
	}

	export default {
		name: "PaymentMethodsVIE",

		components: {
			OrderSummary,
			VueRecaptcha,
		},

		props: {
			payments: {
				type: Object,
			},
			items: {
				type: Array,
			},
			step: {
				type: Number,
			},
			summary: {
				type: Object,
			},
			customerToken: {
				type: String,
				default: '',
			},
			flexpayStore: {
				type: String,
				default: null,
			},
			orderData: {
				type: Object,
			},
			taxExempt: {
				type: Object,
			},
			is_logged_in: {
				type: Boolean,
			},
			placing_order: {
				type: Boolean,
				default: false,
			},
			enableSameAddressAsShipping: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				add_coupon_code: '',
				add_discount_code: '',
				applied_discount: null,
				share_order_info: this.$globs['is_inst'],

				flexpay: {
					username: '',
					password: '',
				},

				selected_restricted_method: null,
				eligible_items: null,

				password: {
					form: false,
					first: '',
					second: '',
				},

				rules: {
					password1: [
						v => v.trim().length > 0 || !this.account_required || "Account is required",
						v => (v.length === 0 || v.trim().length >= 8) || "Min 8 characters",
					],
					password2: [
						v => this.password.first === '' || v !== '' || "Please re-type your password",
						v => v === this.password.first || "Passwords don't match",
					],
					sc_cvv: [
						v => v.length === 3 || "CVV is required",
					],
				},

				third_party_enabled: true,
				captcha_dialog: false,
				captcha_response: null,
			};
		},

		methods: {
			formatPrice,

			async submit() {
				const self = this;
				const payments = await self.payments_data;

				self.$emit('submit', {
					success: true,
					data: payments,
				});
			},

			onCaptchaVerify(response) {
				this.captcha_response = response;
				this.captcha_dialog = false;
			},

			resetCaptchas() {
				this.captcha_response = null;

				if (this.$refs['recaptcha']) {
					this.$refs['recaptcha'].reset();
				}
				if (this.$refs['recaptcha_coupon']) {
					this.$refs.recaptcha_coupon.reset();
				}
			},

			doTracking() {
				if (typeof sendFBPixelAction === 'function') {
					sendFBPixelAction('AddPaymentInfo', {});
				}
				if (typeof sendGAAction === 'function') {
					sendGAAction('Checkout: saved CC selected');
				}
			},

			dismissError(name) {
				this.braintree_invalid_fields = _.without(this.braintree_invalid_fields, name);
			},
		},

		mounted() {
			const self = this;

			EventBus.$on('error-dismissed', (name) => {
				self.dismissError(name);
			});
		},

		computed: {
			account_required() {
				return this.$globs['account_required'] || this.$globs['has_rental'] || this.$globs['has_exchange'];
			},

			all_items() {
				const self = this;
				const result = [];

				_.forEach(self.items, section => {
					_.forEach(section.books, item => {
						result.push(item);
					});
				});

				return result;
			},

			amount_to_authorize() {
				return this.summary['cc_payment'];
			},
		},

		asyncComputed: {
			async payments_data() {
				const self = this;
				const gcs = self.payments.gift_certificates && self.payments.gift_certificates.options
					? _.map(
						_.filter(self.payments.gift_certificates.options, opt => opt.selected), x => x.id)
					: [];

				let payments = {
					financial_aid: self.payments.financial_aid ? self.payments.financial_aid.selected : null,
					gift_certificates: gcs,
					promotion_code: self.applied_discount ? self.applied_discount.code : null,
					credit_card_id: null,
					share_order_info: self.share_order_info,
					device_data: '',
					account_number: null,
					card_type: null,
					billing_address: null,
					customer_password: self.password.first,
					customer_password_confirm: self.password.second,
					captcha_response: self.captcha_response,
					selected: (self.payments.financial_aid && self.payments.financial_aid.selected) || gcs.length > 0,
				};

				payments.selected = true;
				return payments;
			},

			async submit_enabled() {
				const pd = await this.payments_data;
				return pd && pd.selected;
			},

		},
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #4185f4;

	.co-section {
		padding: 4px;
	}

	.co-submit-panel {
		display: flex;
		align-items: center;

		.co-submit-total {
			padding-left: 25px;
			font-size: 16px;
		}
	}

	.co-payments-sections-container {
		width: 100%;

		.co-payments-sections {

			.co-payments-section-with-permissions,
			.co-payments-section-without-permissions {
				.co-payments-section-books {
					padding: 0 30px;

					h3 {
						color: #898C90;
						font-weight: normal;
					}

					.co-permissions-totals {
						padding-top: 10px;
						border-top: 1px solid #ccc;
						margin-top: 10px;
					}
				}
			}

			.co-payments-section-with-permissions {
				padding: 20px 0 20px 24px;
				border-bottom: 1px solid #ccc;
			}

			.co-payments-section-without-permissions {
				padding: 20px 0 0 24px;
			}

			.co-payments-section-no-permissions {
				padding: 0 0 0 24px;
			}

			.co-payments-section-additional {
				padding: 0 0 0 24px;
			}

			ul.co-products-list {
				list-style: none;
				padding: 10px 0 0;

				> li {
					overflow: hidden;
					padding: 10px 0;

					&:first-child {
						border-top: none;
					}

					h3 {
						color: #787878;
						font-size: 16px;
						font-weight: normal;
						margin-bottom: 10px;
						text-transform: uppercase;
					}

					.copl-cover {
						display: block;
						float: left;
						width: 8%;
						margin-right: 2%;
					}

					.copl-info {
						display: block;
						box-sizing: border-box;
						float: left;
						width: 90%;
						padding: 0;

						h4 {
							font-size: 15px;
						}

						div {
							font-size: 14px;
						}
					}
				}
			}


			/deep/ .co-payments-container-radio-group {
				width: 100%;

				> .v-input__control {
					flex-grow: 1;
				}
			}

			.co-payments-container {
				overflow: hidden;
				width: 100%;

				.co-payments-section-content {
					padding: 20px;
				}

			}

			&.co-payments-sections-brief {
				> ul {
					list-style: none;
					margin: 0;
					padding: 0 0 0 40px;

					> li {
						font-size: 16px;
						padding: 5px 0;
					}
				}
			}

			/deep/ ul.co-payments-selector {
				list-style: none;
				padding: 0;
				margin: 0;

				> li {
					.co-select-cc-rg {
						.v-input__control {
							flex-grow: 1 !important;
						}
					}

					&.cops-cc {
						ul.cops-ccs-list {
							list-style: none;

							> li {
								padding: 15px 0px;
								border-bottom: 1px solid #E0E0E0;
							}
						}

						.co-cc-type-selector-container {
							padding: 16px 0 0 0;

							.co-cc-type-selector-title {
								padding: 0 0 0 28px;
							}

							.co-cc-type-selector {
								padding: 0 0 0 48px;
							}
						}
					}


					.cops-3rd-party {
						border-bottom: 1px solid #E0E0E0;
						padding: 0 0 20px;
						margin-bottom: 20px;
						display: flex;
						justify-content: flex-start;

						.cops-3rd-party-btn {
							display: flex;
							justify-content: center;
						}

						.flex {
							&:empty {
								display: none;
								flex: none;
							}
						}

					}

					.cops-flexpay {
						margin-bottom: 20px;
					}

					.cops-add {
						padding-top: 20px;

						@media screen and (max-width: 600px) {
							flex-direction: column;
						}

						.cops-add-caption {
							flex: 1;
						}
					}

					.co-code-submit-btn-block {
						padding-top: 7px;
						margin-top: -5px;
					}
				}
			}
		}

		.co-save-password-block {
			margin-top: 10px;
			border-top: 1px solid #E0E0E0;

			.co-save-password-block-title {
				margin-bottom: 10px;
				color: @text_highlight_color;
			}

			.co-save-password-form {
				margin: 0 0 15px;
			}
		}
	}

	.co-captcha-panel {
		margin: 10px 0;
		border-top: 1px solid #E0E0E0;
		padding: 15px 24px 0;
		@media screen and (max-width: 600px) {
			padding: 10px 0 0;
			display: flex;
			justify-content: center;
			max-width: 100vw;
		}
	}

	.third-party-payment-info-block {
		align-items: center;

		p {
			flex: 1;
			margin-bottom: 0;
		}
	}

	.co-submit-placing-order {
		padding: 30px 32px 20px;

		h4 {
			font-weight: normal;
			font-style: italic;
			font-size: 18px;
		}
	}

	/deep/ .v-text-field .v-label {
		top: 6px !important;
	}

	/deep/ .co-sc-cvv-block {
		padding: 0 0 16px 48px !important;

		.v-input {
			padding-top: 0;
			margin-top: 0;
		}
	}

</style>
